<a
    class="pill pill--partner"
    (click)="openDocument()">
    <i class="las la-folder-open"></i>
    {{ document.name }}
</a>
